import { render, staticRenderFns } from "./quanXianTable.vue?vue&type=template&id=0b8d051c&"
import script from "./quanXianTable.vue?vue&type=script&lang=js&"
export * from "./quanXianTable.vue?vue&type=script&lang=js&"
import style0 from "./quanXianTable.vue?vue&type=style&index=0&id=0b8d051c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports